import { EntityTabPosts } from '../../EntityTab'
import { useRequestProfileContext } from '../RequestProfile.hooks'

import {
  QA_NAME_REQUEST_PROFILE_TAB_POSTS,
  REQUEST_PROFILE_TAB_POSTS_FILTER_KEY,
} from './RequestProfileTabPosts.constants'
import { useRequestPostCreation } from './RequestProfileTabPosts.hooks'

function RequestProfileTabPosts() {
  const { registerPostsTabReload, requestData } = useRequestProfileContext()

  const { addNewQaName, addNewText, canCreate, onCreate } =
    useRequestPostCreation()

  return (
    <EntityTabPosts
      addNewQaName={addNewQaName}
      addNewText={addNewText}
      canCreate={canCreate}
      qaName={QA_NAME_REQUEST_PROFILE_TAB_POSTS}
      scopeFilterKey={REQUEST_PROFILE_TAB_POSTS_FILTER_KEY}
      scopeId={requestData?.id}
      onCreate={onCreate}
      onRegisterReload={registerPostsTabReload}
    />
  )
}

export default RequestProfileTabPosts
